module.exports = __webpack_public_path__ + "04_very_short_black.2cfd5d62.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/04_very_short_black.png
// module id = iahk
// module chunks = 0